import { SplitClient } from '@/plugins/split/SplitClient'

/**
 * SplitIO Vue plugin object
 * @type {PluginObject<unknown>}
 */
export const SplitPlugin = {
  /**
   * @type PluginFunction
   * @param Vue
   */
  install: Vue => {
    /** @type {SplitManager} */
    Vue.prototype.$split = SplitClient
    Vue.prototype.$isSplitEnabled = (split) => SplitClient.isSplitEnabled(split)
  }
}
